import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges
} from '@angular/core';
import tinycolor from 'tinycolor2';
import { IAnyColor } from './color-picker.type';

@Component({
  selector: 'bixi-color-block',
  exportAs: 'bixiColorBlock',
  host: {
    '[class.bixi-color-block]': 'true',
    '[class.bixi-color-block-dark]': 'isDarkColor',
    '[class.bixi-color-block-light]': '!isDarkColor',
    '[style.background-color]': 'rgbString'
  },
  template: `<ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiColorBlockComponent implements OnChanges {
  rgbString = 'transparent';
  isDarkColor = false;
  @Input() color: IAnyColor;

  ngOnChanges() {
    const colorInstance = tinycolor(this.color);
    this.rgbString = colorInstance.toRgbString();
    this.isDarkColor = colorInstance.isDark();
  }
}
